/* Sticky header CTA: once the visitor scrolls past the page's main "Train with us" button, the header's
   Sign Up Now turns BOXR gold (desktop) and appears in the header on phones, and a small gold Sign Up Now
   pill floats at the bottom of the screen (10/21). */
(function () {
  var hdr = document.querySelector("[data-hdr]"), cta = hdr && hdr.querySelector(".hdr__cta");
  if (!cta) return;
  var mark = document.querySelector(".hero__act .btn, .jx-pick, main .btn--solid"), raf = 0;
  /* floating Sign Up Now pill at the bottom of the screen (not on the Join page itself) */
  var fl = null;
  if (!document.body.classList.contains("p-join")) {
    fl = document.createElement("a"); fl.className = "fcta"; fl.href = cta.getAttribute("href"); fl.textContent = "Sign Up Now";
    fl.tabIndex = -1; fl.setAttribute("aria-hidden", "true"); document.body.appendChild(fl);
  }
  var check = function () {
    raf = 0;
    var on = mark ? mark.getBoundingClientRect().bottom < (hdr.offsetHeight || 64) : window.scrollY > window.innerHeight * 0.8;
    hdr.classList.toggle("is-cta", on);
    if (fl) {
      fl.classList.add("is-on"); fl.tabIndex = 0; fl.setAttribute("aria-hidden", "false");   /* 10/21: on screen the whole time, hero to footer */
    }
  };
  window.addEventListener("scroll", function () { if (!raf) raf = requestAnimationFrame(check); }, { passive: true });
  window.addEventListener("resize", check); window.addEventListener("load", check);
  check();
})();
